<template>
    <vx-modal v-model:visible="visible" padding="standard" size="md">
        <template v-slot:header>Edit Contact</template>

        <div>
            <div class="vx-flex vx-flex-col vx-gap-4">
                <vx-alert v-if="error" color="danger" :closeable="false">{{ error }}</vx-alert>
                <div>
                    <vx-label size="lg">First Name</vx-label>
                    <vx-input v-model="firstName" size="lg" ref="firstNameInput"/>
                </div>
                <div>
                    <vx-label size="lg">Last Name</vx-label>
                    <vx-input v-model="lastName" size="lg" />
                </div>
            </div>
        </div>
        <template v-slot:footer>
            <div class="vx-flex vx-flex-col-reverse vx-gap-4 lg:vx-flex-row">
                <vx-button
                    @click="
                        error = '';
                        visible = false;
                    "
                    color="muted"
                    size="lg"
                    type="button"
                    :disabled="saving"
                >
                    Cancel
                </vx-button>
                <vx-button @click="submit" type="button" color="primary" size="lg" class="vx-grow" :loading="saving" data-test="submit">
                    Save
                </vx-button>
            </div>
        </template>
    </vx-modal>
</template>
<script setup>
import { VxModal, VxAlert, VxButton, VxInput, VxLabel } from '@voxie/frontend-components';
import { ref, watch, nextTick } from 'vue';
import { useContactDetails } from '~/components/contacts/contact/useContactDetails';

const visible = defineModel({
    default: false,
});

const { saving, contact, save, error } = useContactDetails();

const firstNameInput = ref();
const firstName = ref('');
const lastName = ref('');

const submit = async () => {
    if (saving.value) {
        return;
    }

    saving.value = true;
    error.value = '';

    const originalFirstName = contact.value.first_name;
    const originalLastName = contact.value.last_name;

    try {
        contact.value.first_name = firstName.value;
        contact.value.last_name = lastName.value;

        await save();

        visible.value = false;
    } catch (e) {
        contact.value.first_name = originalFirstName;
        contact.value.last_name = originalLastName;
    } finally {
        saving.value = false;
    }
};

watch(
    () => visible.value,
    async () => {
        firstName.value = contact.value.first_name;
        lastName.value = contact.value.last_name;

        if (visible.value){
            await nextTick();
            firstNameInput.value?.field?.focus?.()
        }
    },
    {
        immediate: true,
    }
);
</script>
